<template>
  <div :class="$style.container">
    <img :src="contact.photoUrl || defaultAvatar" alt="" :class="$style.avatar" />

    <div :class="$style.details">
      <ContactDetails :contact="contact" />

      <PhoneNumber
        v-for="(phoneNumber, index) in contact.phoneNumbers"
        :key="`${phoneNumber.number}.${index}`"
        :contact="contact"
        :phone="phoneNumber" />

      <p v-if="contact.phoneNumbers.length === 0" :class="$style.noPhoneNumbers">No phone numbers</p>
    </div>
  </div>
</template>

<script>
  import ContactDetails from './ContactDetails'
  import PhoneNumber from './PhoneNumber'

  export default {
    components: {
      ContactDetails,
      PhoneNumber
    },
    props: [
      'contact'
    ]
  }
</script>

<style module lang="less" src="./ContactComponent.less"></style>



// WEBPACK FOOTER //
// ContactComponent.vue?4dc5a6e4